import * as React from "react";
import {
  Heading as ChakraHeading,
  type HeadingProps as ChakraHeadingProps,
} from "@chakra-ui/react";

export const Heading: React.FC<ChakraHeadingProps> = ({ children, ...rest }) => {
  return <ChakraHeading {...rest}>{children}</ChakraHeading>;
};
